import Vue from 'vue';
export default Vue.extend({
  data: () => ({
    notifications: [] as StackingNotification[]
  }),
  methods: {
    addNotification(input: StackingNotificationInput){
      this.notifications.push({...input});
    },
    removeNotification(message: string){
      this.notifications = this.notifications.filter(notif => notif.message != message);
    },
    clearAllNotification(){
      this.notifications = [];
    }
  }
})

export type StackingNotificationInput = {
  message: string
}

export type StackingNotification = {
  message: string
}